import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Person } from "../../types/person";

export interface MasterDataState {
  users: Person[];
  isUsersLoaded: boolean;
  isUsersLoading: boolean;
}

const initialState: MasterDataState = {
  users: [],
  isUsersLoaded: false,
  isUsersLoading: false,
};

const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: {
    setUsersLoading: (state, action: PayloadAction<boolean>) => {
      state.isUsersLoading = action.payload;
    },
    setUsersData: (state, action: PayloadAction<Person[]>) => {
      state.users = action.payload;
      state.isUsersLoaded = true;
      state.isUsersLoading = false;
    },
  },
});

export const { setUsersLoading, setUsersData } = masterDataSlice.actions;
export default masterDataSlice.reducer;
